

class HeaderTopMenu {
	constructor(elem) {
		this.elem = elem[0]; //futureproof by stripping jquery dependency
		this.langButton = this.elem.querySelector('[js-lang-button]');
		this.langMenu = this.elem.querySelector('[js-lang-menu]');
		this.langMenuOpen = this.langMenu.getAttribute('aria-visible') === 'true' || false;
		this.langButton.addEventListener('click', () => this.langMenuOpen ? this.closeMenu() : this.openMenu());

		document.addEventListener('click', (event) => {
			if (this.langMenuOpen && !this.langButton.contains(event.target) && !this.langMenu.contains(event.target)) {
				this.closeMenu()
			}
		})
	}

	openMenu() {
		this.langButton.setAttribute('aria-expanded', 'true');
		this.langButton.classList.add('active');

		this.langMenu.classList.add('-visible', '-animate');
		setTimeout(() => {
			//remove after 150ms, same as css
			this.langMenu.classList.remove('-animate');
		}, 150);
		this.langMenu.setAttribute('aria-visible', 'true');
		this.langMenu.setAttribute('aria-hidden', 'false');
		this.langMenuOpen = true;
	}

	closeMenu() {
		this.langButton.setAttribute('aria-expanded', 'false');
		this.langButton.classList.remove('active');

		this.langMenu.classList.remove('-visible');
		this.langMenu.classList.add('-animate--collapse');
		setTimeout(() => {
			//remove after 150ms, same as css
			this.langMenu.classList.remove('-animate--collapse');
		}, 150);
		this.langMenu.setAttribute('aria-visible', 'false');
		this.langMenu.setAttribute('aria-hidden', 'true');
		this.langMenuOpen = false;
	}
}

export default HeaderTopMenu;